import React from "react";
import { Link } from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAdminPath } from "../../util/router";
import {
   faDownload,
   faEuroSign,
   faGauge,
   faStamp,
   faStoreAlt,
   faWallet,
} from "@fortawesome/free-solid-svg-icons";

const ICON_STYLE = { width: 20 };

const customerMenuItem = (path, icon, labelId) => ({
   key: getAdminPath(path),
   label: (
      <Link to={getAdminPath(path)}>
         <span className="icon" style={ICON_STYLE}>
            <FontAwesomeIcon icon={icon} />
         </span>
         <span>
            <IntlMessages id={labelId} />
         </span>
      </Link>
   ),
});

/**
 * Voci di menu (antd Menu `items`) dell'area di lavoro del cliente corrente
 */
const getSidebarCustomerItems = (client) => {
   if (!client) return [];

   return [
      customerMenuItem("workarea", faGauge, "sidebar.dashboard"),
      customerMenuItem("workarea/dossier", faStamp, "common.dossiers"),
      customerMenuItem("workarea/tari", faEuroSign, "common.tari"),
      customerMenuItem("workarea/invoices", faWallet, "common.invoices"),
      customerMenuItem(
         `customers/update/${client.id}#2`,
         faStoreAlt,
         "tax_accounts.tax_accounts_stores"
      ),
      customerMenuItem("workarea/assets", faDownload, "sidebar.customer_assets"),
   ];
};

export default getSidebarCustomerItems;
